import React, { Component } from "react";
import cn from "classnames";
import { FormattedMessage } from "react-intl";

import { dataURItoBlob } from "../../../../../../../../common/helpers/dataURItoBlob";
import { generatePath } from "../../../../../../../paths";

import Modal from "../../../../../../Modal";
import { Title, Cancel } from "../../../../../../Form";
import Draggable from "../../../../../../Draggable";

import { getImageDimensions, IGetImageDimensionsThis } from "../methods";
import { Container, Button, Wrapper, Window, Point, DeleteButton } from "../shared-style";

import messages from "./messages";
import { IProps, IState } from "./interfaces";
import { IBarsortingData } from "../../../../../../../../common/types";

const pdfjsWorker = require("pdfjs-dist/build/pdf.worker.entry");
const PDF = require("pdfjs-dist/build/pdf");

PDF.GlobalWorkerOptions.workerSrc = pdfjsWorker;


class Upload extends Component<IProps, IState> {
    upload?: HTMLDivElement;
    input?: HTMLInputElement;
    img?: HTMLImageElement;
    state: IState = {
        width: 0,
        height: 0,
        incorrectType: false,
        scale: 1,
        pointA: null,
        pointB: null,
        imageBlob: null,
        inProgress: false,
    };
    blobLoaded = () => {
        const { width, height } = getImageDimensions.call(this as unknown as IGetImageDimensionsThis);
        let pointA = {
            x: 0,
            y: 0,
        };
        let pointB = {
            x: width,
            y: height,
        };

        this.setState({
            pointA,
            pointB,
        });
    };
    componentDidMount() {
        setTimeout(this.resize);
        window.addEventListener("resize", this.resize);
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.resize);
    }
    resize = () => {
        if (this.upload && this.upload.parentElement) {
            let scale = this.upload.parentElement.getBoundingClientRect().width / 1280;
            this.setState({ scale });
        }
    };
    setPoint = (point: "A" | "B", x: number, y: number) => {
        const { width, height, pointA, pointB } = this.state;
        x = Math.min(x, width);
        y = Math.min(y, height);
        if (x < 0) x = 0;
        if (y < 0) y = 0;
        if (point === "A") {
            x = Math.min(x, pointB!.x - 50);
            y = Math.min(y, pointB!.y - 50);
            this.setState({
                pointA: {
                    x, y,
                },
            })
        } else {
            x = Math.max(x, pointA!.x + 50);
            y = Math.max(y, pointA!.y + 50);
            this.setState({
                pointB: {
                    x, y,
                },
            })
        }
    };

    inputFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!e.target.files![0]) return;
        let type = e.target.files![0].type;
        if (type !== "image/png" && type !== "image/jpeg" && type !== "application/pdf") {
            this.input!.value = "null";
            return this.setState({ incorrectType: true });
        }

        let reader = new FileReader();
        reader.readAsDataURL(e.target.files![0]);
        reader.onload = async e => {
            let blob = window.URL.createObjectURL(dataURItoBlob(e.target!.result as string));
            if (type !== "application/pdf") {
                this.setState({ imageBlob: blob, width: 0, height: 0 });
            } else {
                const pdf = await PDF.getDocument(blob).promise;
                const page = await pdf.getPage(1);
                const canvas = document.createElement("canvas");
                const context = canvas.getContext("2d");
                const viewport = page.getViewport({ scale: 2 });
                canvas.height = viewport.height;
                canvas.width = viewport.width;
                const renderContext = {
                    canvasContext: context,
                    viewport,
                };
                let renderTask = page.render(renderContext);
                await renderTask.promise;
                let base64image = canvas.toDataURL("image/jpeg", 1);
                this.setState({ imageBlob: base64image, width: 0, height: 0 });
            }
        };
    };
    cropAndUpload = () => {
        const { imageBlob, pointA, pointB, width, height } = this.state;
        let canvas = document.createElement("canvas");
        let proposedWidth = this.img!.naturalWidth * ((pointB!.x - pointA!.x) / width);
        let proposedHeight = this.img!.naturalHeight * ((pointB!.y - pointA!.y) / height);
        let scale = 1;
        if (proposedWidth > 1280) {
            scale = 1280 / proposedWidth;
            proposedWidth = 1280;
            proposedHeight = scale * proposedHeight;
        }
        if (proposedHeight > 720) {
            scale *= 720 / proposedHeight;
            proposedWidth *= 720 / proposedHeight;
            proposedHeight = 720;
        }
        canvas.width = proposedWidth;
        canvas.height = proposedHeight;

        const ctx = canvas.getContext("2d")!;
        const img = new Image();
        img.onload = () => {
            let x = pointA!.x * (this.img!.naturalWidth / width);
            let y = pointA!.y * (this.img!.naturalHeight / height);
            ctx.fillStyle = "white";
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.scale(scale, scale);
            ctx.drawImage(img, -x, -y);
            let base64image = canvas.toDataURL("image/jpeg", 0.8);
            const { plan, taskIndex, post, editTask } = this.props;
            this.setState({ inProgress: true });
            post(
                "score-editor-upload",
                {
                    planId: plan._id,
                    index: taskIndex,
                    image: base64image,
                },
                res => {
                    const { data } = res;
                    if (res.status === 413) {
                        return alert("A feltöltött fájl mérete túl nagy!");
                    } else {
                        editTask({ taskIndex, changingProp: "score", val: data.file });
                        this.props.setLatestStage();
                    }
                    this.setState({
                        inProgress: false,
                        imageBlob: null,
                        pointA: null,
                        pointB: null,
                        width: 0,
                        height: 0,
                    });
                }
            );
        };
        img.src = imageBlob!;
    };

    deleteScore = () => {
        const { plan, taskIndex, post, clearTask, setLatestStage } = this.props;
        clearTask({ taskIndex });
        setLatestStage();
        post("score-editor-delete", { planId: plan._id, index: taskIndex });
    };

    render() {
        const data = this.props.task.data as IBarsortingData;
        const { width, height, incorrectType, imageBlob, pointA, pointB, scale } = this.state;
        let topOffset = 0;
        let leftOffset = 0;

        if (!imageBlob && (!data || !data.score)) {
            return (
                <Container ref={el => (this.upload = el!)}>
                    <Button>
                        <button
                            className={"button"}
                            onClick={() => {
                                this.input!.click();
                            }}
                        >
                            <FormattedMessage {...messages.selectScore} />
                        </button>
                    </Button>
                    <input
                        type="file"
                        accept="image/jpeg, image/png, application/pdf"
                        style={{ display: "none" }}
                        ref={input => (this.input = input!)}
                        onChange={this.inputFileChange}
                    />
                    {incorrectType && (
                        <Modal close={() => this.setState({ incorrectType: false })}>
                            <Title>
                                <FormattedMessage {...messages.fileUpload} />
                            </Title>
                            <p>
                                <FormattedMessage {...messages.fileIncorrectFormat} />
                            </p>
                            <p>
                                <FormattedMessage {...messages.imageTypes} />
                            </p>
                            <Cancel onClick={() => this.setState({ incorrectType: false })}>
                                <FormattedMessage {...messages.close} />
                            </Cancel>
                        </Modal>
                    )}
                </Container>
            );
        } else if (imageBlob && (!data || !data.score)) {
            return (
                <Container ref={el => (this.upload = el!)}>
                    <Wrapper>
                        <img
                            src={imageBlob /*generatePath(data.score)*/}
                            ref={img => (this.img = img!)}
                            onLoad={this.blobLoaded}
                            width={width}
                            height={height}
                            alt="score"
                        />
                        {!!pointA && !!pointB && (
                            <>
                                <Draggable
                                    position={{
                                        x: pointA.x + leftOffset,
                                        y: pointA.y + topOffset,
                                    }}
                                    scale={scale}
                                    onDrag={(x, y) => this.setPoint("A", x - leftOffset, y - topOffset)}
                                >
                                    <Point style={{ cursor: "nwse-resize" }} />
                                </Draggable>
                                <Draggable
                                    position={{
                                        x: pointB.x + leftOffset,
                                        y: pointB.y + topOffset,
                                    }}
                                    scale={scale}
                                    onDrag={(x, y) => this.setPoint("B", x - leftOffset, y - topOffset)}
                                >
                                    <Point style={{ cursor: "nwse-resize" }} />
                                </Draggable>
                                <Window
                                    style={{
                                        top: pointA.y,
                                        left: pointA.x,
                                        width: pointB.x - pointA.x,
                                        height: pointB.y - pointA.y,
                                    }}
                                />
                            </>
                        )}
                    </Wrapper>
                    <Button>
                        <button className={"button"} onClick={this.cropAndUpload}>
                            <FormattedMessage {...messages.uploadScore} />
                        </button>
                    </Button>
                </Container>
            );
        } else {
            return (
                <Container ref={el => (this.upload = el!)}>
                    <Wrapper>
                        <img
                            src={generatePath(data.score!)}
                            ref={img => (this.img = img!)}
                            onLoad={() => getImageDimensions.call(this as unknown as IGetImageDimensionsThis)}
                            width={width}
                            height={height}
                            alt="score"
                        />
                    </Wrapper>
                    <Button>
                        <DeleteButton className={cn("button", "button--light")} onClick={this.deleteScore}>
                            <FormattedMessage {...messages.deleteScore} />
                        </DeleteButton>
                    </Button>
                </Container>
            );
        }
    }
}

export default Upload;
